interface DepartingRoom {
  onLeave(callback: (code: number) => void): void;
  leave(): Promise<number>;
}

/** Track immediately after joining; reset and effect cleanup share one departure. */
export class RoomDepartures {
  private readonly rooms = new WeakMap<DepartingRoom, { closed: boolean; leaving?: Promise<void> }>();

  track(room: DepartingRoom): void {
    if (this.rooms.has(room)) return;
    const state = { closed: false };
    this.rooms.set(room, state);
    room.onLeave(() => { state.closed = true; });
  }

  leave(room: DepartingRoom): Promise<void> {
    this.track(room);
    const state = this.rooms.get(room);
    if (!state) throw new Error("Room departure is not tracked");
    if (state.leaving) return state.leaving;
    if (state.closed) return Promise.resolve();
    state.leaving = room.leave().then(() => { state.closed = true; });
    return state.leaving;
  }
}
